import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { getRouterLocale } from '../../Utils/i18Utils/constant';
import {
  fireClickedVarientOption,
  queryParamHandling,
} from '../../Utils/productPageUtils';
import ProductColor from '../ProductNew/ProductColor';
import SizeandPacks from '../ProductNew/SizeandPacks';
import SizeChartPopup from '../ProductNew/sizeChartPopup';
import SizePopup from '../ProductNew/sizePopup';
import Cookies from 'js-cookie';
import { productActionClick } from '../../Utils/productAction';
import {
  maternitySkusList,
  maternityVariantData,
} from './OfferCarousel/constant';
import ProductType from '../ProductNew/ProductType';

export default function SizeAndPacksCover(props) {
  const {
    productData,
    showSizePopup,
    setShowSizePopup,
    setShowFadeEffect,
    setAddedToCart,
    showNewDiaperVariantUx,
    isVariantPopup,
    handleClose,
    showNewLactomamaVariantUx,
    setUserSelectedVariant,
    setSelectedVariant,
    userSelectedVariant,
    generalItemsDataByFlavour,
    flavourTitles,
    setGeneralItems,
    tabThemeColor,
    setTabThemeColor,
    setTabThemeSecondaryColor,
   
  } = props;
  const sizeVarient = useRef({});
  const VarientSelected = useRef('');
  const [showSizeChartPopup, setShowSizeChartPopup] = useState(false);
  const [sameVariantSeleted, setSameVariantSeleted] = useState(false);
  // const [delayClick, setDelayClick] = useState(false);
  const [sizePopupButtons, setSizePopupButtons] = useState(true);
  const [selectedData, setSelectedData] = useState({});
  const [updateVariant, setUpdateVariant] = useState(false);
  const router = useRouter();
  const [packsCount, setPacksCount] = useState(0);
  const showCDNewVariantUx = [3997].includes(productData.variant_id);

  const varientSelectedHandler = (value) => {
    VarientSelected.current = value;
  };
  const clickProductColorHandler = (
    url,
    option,
    selectedAttribute,
    type,
    from,
  ) => {
    // if (!delayClick) {
    if (selectedAttribute == 'Size') {
      varientSelectedHandler(type);
    }
    setShowFadeEffect(true);
    // setDelayClick(true);
    // setTimeout(() => {
    //     setDelayClick(false);
    // }, 300);
    fireClickedVarientOption(
      selectedAttribute,
      option,
      type,
      from,
      productData,
    );
    const { addParams, newUrl } = queryParamHandling(url);
    // If Same Variant is selected then don't update the URL
    if (router.asPath != newUrl + addParams) {
      setSameVariantSeleted(false);
      Cookies.set('selectedDiaper', url);
      router.replace(newUrl + addParams, undefined, {
        locale: getRouterLocale(router),
      });
    } else {
      if (sameVariantSeleted) {
        if (setShowSizePopup) setShowSizePopup(false);
        if(option?.product_id){
        productActionClick('cart', { id: option.product_id }, 1);
        }
        setSameVariantSeleted(false);
      } else {
        setSameVariantSeleted(true);
      }
    }
    // }
  };
  const setVarientType = (productData, data, item) => {
    if (item?.variant_type == 'Size' && productData?.isFashionFirst) {
      return VarientSelected.current || '';
    }
    return data?.title;
  };
  useEffect(() => {
    const selectedDataString = localStorage.getItem('selectedVariant');
    const data = JSON.parse(selectedDataString);
    if (data) {
      setSelectedData(JSON.parse(selectedDataString));
      setShowFadeEffect(false);
    }
  }, [updateVariant]);
  useEffect(() => {
    const variantInfo = productData?.variantOption;
    const variantDetails = {};
    variantInfo?.forEach((item) => {
      item.data.forEach((data) => {
        if (data?.selected == '1') {
          variantDetails['productId'] = data?.product_id;
          variantDetails[item.variant_type.toUpperCase()] = setVarientType(
            productData,
            data,
            item,
          );
        }
      });
    });
    localStorage.setItem('selectedVariant', JSON.stringify(variantDetails));
    setUpdateVariant(!updateVariant);
    const count = parseInt(Cookies.get('variantSize')) || 0;
    setPacksCount(count);
  }, [productData?.id]);

  const selectedVariantType = maternityVariantData.find(
    (ele) => ele.product_id == productData?.variant_id,
  );

  return (
    <>
      {/* {maternitySkusList.includes(parseInt(productData?.id)) && (
                <ProductType
                    varientData={maternityVariantData}
                    varientTitle={"Type"}
                    productDetail={productData}
                    selectedData={selectedVariantType || {}}
                    showNewDiaperVariantUx={showNewDiaperVariantUx}
                    clickProductColorHandler={clickProductColorHandler}
                />
            )} */}
      {productData?.variantOption?.map((varient, index) => {
        if (varient?.variant_type == 'Size') sizeVarient.current = varient;

        switch (varient?.dispaly_style) {
          case '1':
            return (
              ![2890, 2891, 2892, 2893].includes(parseInt(productData?.id)) && (
                <SizeandPacks
                  clickProductColorHandler={clickProductColorHandler}
                  varientData={varient}
                  productDetail={productData}
                  selectedData={selectedData}
                  key={`sizeandpack${index}`}
                  setShowSizeChartPopup={setShowSizeChartPopup}
                  showNewDiaperVariantUx={showNewDiaperVariantUx}
                  isVariantPopup={isVariantPopup}
                  showNewLactomamaVariantUx={showNewLactomamaVariantUx}
                  setUpdateVariant={setUpdateVariant}
                  updateVariant={updateVariant}
                  setUserSelectedVariant={setUserSelectedVariant}
                  setSelectedVariant={setSelectedVariant}
                  packsCount={packsCount}
                  generalItemsDataByFlavour={generalItemsDataByFlavour}
                  flavourTitles={flavourTitles}
                  setGeneralItems={setGeneralItems}
                  setTabThemeColor={setTabThemeColor}
                  setTabThemeSecondaryColor={setTabThemeSecondaryColor}
                  tabThemeColor={tabThemeColor}
                 
                />
              )
            );

          case '2':
          case '3':
            return (
              <ProductColor
                clickProductColorHandler={clickProductColorHandler}
                varientData={varient?.data}
                varientTitle={varient?.variant_type}
                productDetail={productData}
                selectedData={selectedData}
                key={`sizeandpack${index}`}
                showNewDiaperVariantUx={showNewDiaperVariantUx}
                isVariantPopup={isVariantPopup}
                handleClose={handleClose}
                showNewLactomamaVariantUx={showNewLactomamaVariantUx}
                updateVariant={updateVariant}
                setUserSelectedVariant={setUserSelectedVariant}
                setSelectedVariant={setSelectedVariant}
                userSelectedVariant={userSelectedVariant}
                setUpdateVariant={setUpdateVariant}
                packsCount={packsCount}
                showCDNewVariantUx={showCDNewVariantUx}
                tabThemeColor={tabThemeColor}
              />
            );
          default:
            break;
        }
      })}
      {showSizePopup && (
        <SizePopup
          clickProductColorHandler={clickProductColorHandler}
          varientData={sizeVarient.current}
          productDetail={productData}
          selectedData={selectedData}
          setAddedToCart={setAddedToCart}
          showSizePopup={showSizePopup}
          VarientSelected={VarientSelected}
          setShowSizePopup={setShowSizePopup}
          setShowSizeChartPopup={setShowSizeChartPopup}
          sizePopupButtons={sizePopupButtons}
          setSizePopupButtons={setSizePopupButtons}
        ></SizePopup>
      )}
      {showSizeChartPopup && (
        <SizeChartPopup
          clickProductColorHandler={clickProductColorHandler}
          varientData={sizeVarient.current}
          productDetail={productData}
          selectedData={selectedData}
          showSizeChartPopup={showSizeChartPopup}
          setShowSizeChartPopup={setShowSizeChartPopup}
          setSizePopupButtons={setSizePopupButtons}
        ></SizeChartPopup>
      )}
    </>
  );
}
